import {
	SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_RELATIVE_XL,
} from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { StyledDialogContent } from '~/components/dialog/styles/styled-dialog';
import { breakPoints } from '~/styles/break-points';

export const StyledConflictSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};

	.subline {
		color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};
	}
`;

export const StyledConflictDialogWrapper = styled.div`
	${StyledDialogContent} {
		padding-top: 0;

		${breakPoints({
			'1024': `
				padding-top: 0;
			`,
		})}
	}
`;

export const StyledConflictDialog = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_RELATIVE_XL};

	.subline {
		font-size: 1rem;
	}
`;

export const StyledSelectionArea = styled.div`
	display: flex;
	flex-direction: column;

	& > p:first-of-type {
		margin-bottom: 4px;
	}

	.title {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}
`;
